// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7840 ? "f2d0f643" : chunkId) + "." + {"1014":"750edc9cb8d1c89a","1908":"c98d8ea5424a7c8e","3322":"c9cf81f9ced66595","6938":"3285608ec89c2541","7729":"c2dc91c7b1620196","7840":"e5f396d4ebcb658c"}[chunkId] + ".js";
};